import { faQuestionCircle, faTicket } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import {
  FormattedMessage,
  FormattedNumber,
  defineMessages,
  useIntl,
} from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  BodyL,
  HeadlineL,
  HeadlineS,
  LabelS,
} from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { ANY_SPORT_MARKET_PRIMARY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const messages = defineMessages({
  howToWin: {
    id: 'marketplace.wheel.tickets.howToWin',
    defaultMessage: 'How to win tickets?',
  },
});
const Content = styled(Vertical)`
  padding: var(--double-unit);
`;

export const Tickets = ({ nb = 0 }: { nb: number }) => {
  const [open, setOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { sport } = useSportContext();
  return (
    <>
      <Vertical center>
        <HeadlineS>
          <FormattedMessage
            id="marketplace.wheel.tickets.title"
            defaultMessage="Tickets"
          />
        </HeadlineS>
        <HeadlineL>
          <Horizontal>
            <FontAwesomeIcon icon={faTicket} />
            <FormattedNumber value={nb} />
          </Horizontal>
        </HeadlineL>
        <Button color="transparent" size="small" onClick={() => setOpen(true)}>
          <LabelS color="var(--c-nd-500)">
            <Horizontal>
              <FontAwesomeIcon icon={faQuestionCircle} />
              <FormattedMessage {...messages.howToWin} />
            </Horizontal>
          </LabelS>
        </Button>
      </Vertical>
      <Dialog
        open={open}
        maxWidth="xs"
        onClose={() => setOpen(false)}
        title={formatMessage(messages.howToWin)}
      >
        <Content>
          <BodyL>
            <FormattedMessage
              id="marketplace.wheel.tickets.dialog"
              defaultMessage="Win tickets by buying 26 Season Cards, either through auctions or instant buy."
            />
          </BodyL>

          <Button
            size="large"
            fullWidth
            color="purple"
            to={generateSportPath(ANY_SPORT_MARKET_PRIMARY, { sport })}
          >
            <FormattedMessage
              id="marketplace.wheel.tickets.shopCards"
              defaultMessage="Shop Cards"
            />
          </Button>
        </Content>
      </Dialog>
    </>
  );
};
